import { Group, Rect, Text } from 'react-konva';
import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';

import { COLUMN_WIDTH } from 'src/pages/gantt/gantt-calendar/gantt-view/gantt-view.constants';

import { HOURS_BUDGE_SIZE } from './available-hours-badge.constants';
import { IAvailableHoursBadge } from './available-hours-badge.interface';

const { white, blue } = PLATFORM_THEME_COLORS.primary;

const AvailableHoursBadge = ({ columnPoints, availableWorkingHours }: IAvailableHoursBadge) => {
  const [columnStartX, columnStartY] = columnPoints;
  const budgeXPoint = columnStartX + (COLUMN_WIDTH - HOURS_BUDGE_SIZE);

  return (
    <Group visible={!!availableWorkingHours}>
      <Rect
        perfectDrawEnabled={false}
        x={budgeXPoint}
        y={columnStartY}
        width={HOURS_BUDGE_SIZE}
        height={HOURS_BUDGE_SIZE}
        fill={white}
        cornerRadius={[2, 2, 2, 2]}
        shadowColor="black"
        shadowBlur={5}
        shadowOffset={{ x: 1, y: 2 }}
        shadowOpacity={0.15}
      />
      <Text
        fontFamily="Inter"
        text={`${availableWorkingHours}h`}
        align="center"
        verticalAlign="middle"
        x={budgeXPoint}
        y={columnStartY}
        fontSize={10}
        fill={blue}
        width={HOURS_BUDGE_SIZE}
        height={HOURS_BUDGE_SIZE}
      />
    </Group>
  );
};

export default AvailableHoursBadge;
